import React from 'react';
import PropTypes from 'prop-types';
import {withFormsy, propTypes} from "formsy-react";
import {FormGroup, Label, Input, FormFeedback} from 'reactstrap';
import {FormattedMessage} from "react-intl";

export class PhotoInputFormGroup extends React.Component {
    static propTypes = {
        validTypes: PropTypes.arrayOf(PropTypes.string),
        sizeLimit: PropTypes.number,
        showSuccess: PropTypes.bool,
        ...propTypes
    };

    componentWillMount() {
        this.setState({
            error: null
        });
    }

    changeValue(event) {
        const file = event.target.files[0];
        const setValue = this.props.setValue;

        if (!file) {
            return;
        }
        else if (this.props.validTypes && !this.props.validTypes.includes(file.type)) {
            this.setState({
                error: <FormattedMessage id="form.error.invalid_file_type"
                                         defaultMessage="Unsupported file type. Supported types: {types}"
                                         values={{types: this.props.validTypes.join(', ')}}/>
            });
            setValue('');
            return;
        }
        else if (this.props.sizeLimit && file.size > this.props.sizeLimit) {
            this.setState({
                error: <FormattedMessage id="form.error.invalid_size"
                                         defaultMessage="Invalid file size. Maximum file size is: {value} MB"
                                         values={{value: this.props.sizeLimit / 1048576}}/>
            });
            setValue('');
            return;
        }

        this.setState({
            error: null
        });
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            setValue(reader.result);
        });

        reader.readAsDataURL(file);
    }

    render() {
        const {name, id, isPristine, getValue, showSuccess} = this.props;
        const value = getValue();

        return (
            <FormGroup>
                <Label className="custom-file custom-file-photo">
                    <Input className="custom-file-input" valid={!isPristine() && !this.state.error} invalid={this.state.error} name={name} id={id} type="file"
                           onChange={::this.changeValue}/>
                    <span className="custom-file-label"/>
                </Label>

                {this.state.error &&
                <FormFeedback className="d-block">
                    {this.state.error}
                </FormFeedback>
                }

                {showSuccess && !this.state.error && value && value !== '' &&
                <FormFeedback className="d-block" valid>
                    <FormattedMessage id="form.photo.successfully_selected" defaultMessage="Photo was successfully selected"/>
                </FormFeedback>
                }
            </FormGroup>
        )
    }
}

export default withFormsy(PhotoInputFormGroup);


// WEBPACK FOOTER //
// ./src/components/Form/PhotoInputFormGroup.jsx